import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import create from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { USER_ROLE, USER_TYPE } from '../constants/userConstants';
import { claritySetUserProperty } from '../helpers/clarityHelpers';
import { mixpanelSetUserProperty } from '../helpers/mixPanelHelper';
var moment = require('moment').default || require('moment');
export var resolveUserAttributeValue = function resolveUserAttributeValue(selectedUser, scopeAttr, defaultLabelToKey) {
    if (scopeAttr.userAttributeId) {
        var _selectedUser_attributes;
        var attr = ((_selectedUser_attributes = selectedUser.attributes) !== null && _selectedUser_attributes !== void 0 ? _selectedUser_attributes : []).find(function(a) {
            var _ref;
            var _a_userAttributeId, _scopeAttr_userAttributeId;
            var id = (_ref = (_a_userAttributeId = a.userAttributeId) === null || _a_userAttributeId === void 0 ? void 0 : _a_userAttributeId._id) !== null && _ref !== void 0 ? _ref : a.userAttributeId;
            return (id === null || id === void 0 ? void 0 : id.toString()) === ((_scopeAttr_userAttributeId = scopeAttr.userAttributeId) === null || _scopeAttr_userAttributeId === void 0 ? void 0 : _scopeAttr_userAttributeId.toString());
        });
        if (attr) return attr.value;
    }
    var rootField = defaultLabelToKey[scopeAttr.label];
    if (rootField) return selectedUser[rootField];
    return undefined;
};
var initialState = {
    isUserSet: false,
    oid: '',
    displayName: '',
    givenName: '',
    userPrincipalName: '',
    mail: '',
    tenantId: '',
    createdAt: '',
    userType: USER_TYPE.MICROSOFT_365,
    jobTitle: '',
    department: '',
    country: '',
    birthday: '',
    employeeHireDate: '',
    officeLocation: '',
    role: 0,
    isAdmin: false,
    canChangeGeneralSettings: false,
    canEditUserAttributes: false,
    canEditUserManager: false,
    responsibleType: '',
    responsibleDepartments: [],
    responsibleOfficeLocations: [],
    responsibleCountries: [],
    responsibleScopeAttributes: null
};
export var useUserIdentityStore = create(//@ts-ignore
devtools(subscribeWithSelector(function(set) {
    return _object_spread_props(_object_spread({}, initialState), {
        setUserIdentity: function setUserIdentity(data) {
            set(function(state) {
                return _object_spread_props(_object_spread({}, state, data), {
                    // Ensure arrays are properly cloned
                    responsibleDepartments: data.responsibleDepartments ? _to_consumable_array(data.responsibleDepartments) : state.responsibleDepartments,
                    responsibleOfficeLocations: data.responsibleOfficeLocations ? _to_consumable_array(data.responsibleOfficeLocations) : state.responsibleOfficeLocations,
                    responsibleCountries: data.responsibleCountries ? _to_consumable_array(data.responsibleCountries) : state.responsibleCountries
                });
            }, false, 'userIdentity/setUserIdentity');
        },
        reset: function reset() {
            set(initialState, false, 'userIdentity/reset');
        }
    });
}), {
    name: 'UserIdentityStore',
    enabled: process.env.NODE_ENV === 'development'
}));
/**
 * Initialize UserIdentityStore from user data (called during login)
 */ export var initUserIdentityFromUser = function initUserIdentityFromUser(user) {
    var _user_tenant;
    var store = useUserIdentityStore.getState();
    var isAdmin = user.role === USER_ROLE.GlobalAdministrator || user.role === USER_ROLE.ScopedAdministrator;
    store.setUserIdentity({
        isUserSet: true,
        oid: user.oid || '',
        displayName: user.displayName || '',
        givenName: user.givenName || '',
        userPrincipalName: user.userPrincipalName || '',
        mail: user.mail || '',
        tenantId: user.tenantId || '',
        createdAt: user.createdAt || '',
        userType: user.userType || USER_TYPE.MICROSOFT_365,
        jobTitle: user.jobTitle || '',
        department: user.department || '',
        country: user.country || '',
        birthday: user.birthday || '',
        employeeHireDate: user.employeeHireDate || '',
        officeLocation: user.officeLocation || '',
        role: user.role || 0,
        isAdmin: isAdmin,
        responsibleType: user.responsibleType || '',
        responsibleDepartments: user.responsibleDepartments || [],
        responsibleOfficeLocations: user.responsibleOfficeLocations || [],
        responsibleCountries: user.responsibleCountries || [],
        responsibleScopeAttributes: user.responsibleScopeAttributes || null,
        canChangeGeneralSettings: user.canChangeGeneralSettings || false,
        canEditUserAttributes: user.canEditUserAttributes || false,
        canEditUserManager: user.canEditUserManager || false
    });
    // Track new users (created within last hour) in Clarity
    if (moment().diff(moment(user.createdAt), 'hour', true) < 1) {
        claritySetUserProperty('usertype', 'newuser');
    }
    // Track new tenants (created within last hour) in Clarity
    if (((_user_tenant = user.tenant) === null || _user_tenant === void 0 ? void 0 : _user_tenant.createdAt) && moment().diff(moment(user.tenant.createdAt), 'hour', true) < 1) {
        claritySetUserProperty('usertype', 'newtenant');
    }
    // Track user signup rank in Mixpanel
    mixpanelSetUserProperty('Kacinci User', user.signUpRank);
};
